import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../../typings'

/**
 * Refreshes GPS Data
 *
 * @private
 */
export const deleteTenantSource = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/gps/telematics/deleteTenantSource', async (tenantSourceId, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/gps/telematics/deleteTenantSource', {
      tenantSourceId,
      category: 'rpc',
      type: 'rpc/gps/telematics/deleteTenantSource',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(`Unknown error on {deleteTenantSource}`, { tags: ['rpc'] }, 'error')

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Creation of Telematics tenant source Failed`,
      error,
    })
  }
})
